import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Channel } from '@app/shared/models/channel';
import { isArray } from '@app/shared/utils';

export interface ConversationSimulation {
  id: string;
  text: string;
  from?: {
    picture?: string;
    initials?: string;
    channel?: Channel;
  };
  hint?: string;
  position: ConversationPosition;
}

export enum ConversationPosition {
  Left = 'left',
  Right = 'right',
}

interface IConversationSimulation extends ConversationSimulation {
  isTyping: boolean;
}

@Component({
  standalone: false,
  selector: 'sbnb-conversation-simulator',
  templateUrl: './conversation-simulator.component.html',
  styleUrls: ['./conversation-simulator.component.scss', './conversation-simulator.component.mobile.scss'],
})
export class ConversationSimulatorComponent implements OnChanges {
  @Input() conversation: ConversationSimulation[];
  @Input() showNewMessageInput: boolean = false;
  @Input() newMessageHint: string;
  @Input() senderInitials: string;
  @Output() clickedEmbeddedLink: EventEmitter<unknown> = new EventEmitter();

  defaultDelay: number = 1000;
  ConversationPosition = ConversationPosition;
  conversationUi: IConversationSimulation[] = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['conversation'] &&
      changes['conversation'].currentValue &&
      isArray(changes['conversation'].currentValue)
    ) {
      this.conversationUi = [];
      this.updateAndRenderConversation(changes['conversation'].currentValue);
    }
  }

  async updateAndRenderConversation(conversation: ConversationSimulation[]) {
    for (let i = 0; i < conversation.length; i++) {
      await this.addToConversationUi(conversation[i], i === 0 ? 0 : null);
    }
  }

  async addToConversationUi(convo: ConversationSimulation, forcedDelay?: number) {
    return new Promise(
      (resolve, reject) => {
        // setTimeout(
        //   async () => {
        if (!this.conversationUi.length) {
          resolve(true);
        }

        this.conversationUi.push({
          ...convo,
          ...{ isTyping: true },
        });
        const latestConversationIndex = this.conversationUi.length - 1;

        // setTimeout(() => {
        if (this.conversationUi[latestConversationIndex]) {
          this.conversationUi[latestConversationIndex]['isTyping'] = false;
        }
        resolve(true);
        // }, 500);
      }
      //   forcedDelay ? forcedDelay : this.defaultDelay
    );
    // });
  }

  onClickMessageHint(e: HTMLElement) {
    if (e.className.includes('embedded-link')) {
      this.clickedEmbeddedLink.emit();
    }
  }
}
